import { catchError, forkJoin, map, Observable, of } from 'rxjs';

/** An opt-in second source for the customer typeahead (US 36095: dbo prospects on the SRF), searched with the same term. */
// eslint-disable-next-line no-unused-vars -- pre-commit-allow: base rule false positive on a TS function-type parameter name
export type AdditionalCustomerSearch = (
  searchString: string
) => Observable<unknown[]>;

/**
 * US 36095: the base search's rows, then the additional source's, for the same term. The additional source never breaks the
 * picker: an error there yields the base rows alone. With no additional source the base function is returned as is, so the
 * apps that share the control without the option are unchanged.
 */
export function withAdditionalCustomers<A extends unknown[]>(
  // eslint-disable-next-line no-unused-vars -- pre-commit-allow: base rule false positive on a TS function-type parameter name
  base: (...args: A) => Observable<unknown>,
  additional: AdditionalCustomerSearch | undefined
  // eslint-disable-next-line no-unused-vars -- pre-commit-allow: base rule false positive on a TS function-type parameter name
): (...args: A) => Observable<unknown> {
  if (!additional) {
    return base;
  }
  return (...args: A) =>
    forkJoin([
      base(...args),
      additional(String(args[0] ?? '')).pipe(catchError(() => of([]))),
    ]).pipe(
      map(([rows, extra]) => [...((rows as unknown[] | null) ?? []), ...extra])
    );
}
